import { render, staticRenderFns } from "./persons-item.vue?vue&type=template&id=2352670a&"
import script from "./persons-item.vue?vue&type=script&lang=js&"
export * from "./persons-item.vue?vue&type=script&lang=js&"
import style0 from "./persons-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports